import { keyframes } from "styled-components";

export const moveInRight = keyframes`
  from {
    opacity: 0.2;
    transform : translateX(220px)
  }
  to {
    opacity: 1;
    transform : translateX(0)
  }
`;
